import generateAsyncActions from 'utils/generateAsyncActions';
import alt from 'components/Dispatcher';
import CrmOpportunitySource from 'sources/crm-opp-ui/CrmOpportunitySource';

class CrmOpportunityActions {
  constructor() {
    this.generateActions(
      ...generateAsyncActions('fetchOpportunity', 'searchOpportunities', 'fetchStages'),
      'clearSearch',
      'setSearchTerm'
    );
  }

  searchOpportunities(searchTerm) {
    return dispatch => {
      dispatch(searchTerm);
      if (searchTerm && searchTerm.length >= 3) {
        CrmOpportunitySource.searchOpportunities(searchTerm).then(
          this.searchOpportunitiesSuccess,
          this.searchOpportunitiesError
        );
      }
    };
  }

  fetchOpportunity(opportunityId) {
    return dispatch => {
      dispatch(opportunityId);
      return CrmOpportunitySource.fetchOpportunity(opportunityId).then(
        this.fetchOpportunitySuccess,
        this.fetchOpportunityError
      );
    };
  }

  fetchStages() {
    return dispatch => {
      dispatch();
      CrmOpportunitySource.fetchStages().then(this.fetchStagesSuccess, this.fetchStagesError);
    };
  }
}

export default alt.createActions(CrmOpportunityActions);
